import { selector } from '@/lib/selectors';

// Leaf selectors: nothing from domain/ is imported here at runtime, so any
// selector module can depend on this one without an import cycle.
const categories = (state) => state.categories;

export const categoriesListSelector = selector(categories, (e) => e.list);
